import { SecurityService } from '../services/security.service';
import { isEntityEnabled, toPascalCase, SecurityProfile } from '@voice/utils';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { NotificationsService } from '../services/notifications.service';
import { PERMISSIONS_DICTIONARY } from '../utils/permissions-dictionary';

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard implements CanActivate {
  private readonly routeToEntityMap: Record<string, string> = {
    '911-recipients': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
    '911-events': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
    'user-roles': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
    'device-models': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
    'reseller-sku-mappings': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
    'scheduled-jobs': PERMISSIONS_DICTIONARY.netsapiensAdmin.name,
  };

  constructor(
    private readonly securityService: SecurityService,
    private readonly notificationsService: NotificationsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const routePath = route.url[0].path.split('/')[0];
      const entity = this.routeToEntityMap[routePath] || toPascalCase(routePath);
      this.securityService
        .getSecurityProfile()
        .then((securityProfile: SecurityProfile) => {
          if (!isEntityEnabled(securityProfile, entity)) {
            this.notificationsService
              .error(
                "Access denied. You don't have permission to perform this action."
              )
              .then(() => resolve(false));
          } else {
            resolve(true);
          }
        });
    });
  }
}
